let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import UIFlex from 'UIComponents/layout/UIFlex';
import PhoneSupport from 'pricing-pages-ui/components/common/PhoneSupport';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { Section } from './SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PhoneSupportFooter__StyledFlex",
  componentId: "i9y3nz-0"
})(["margin:0 auto;", ";", ";&.phone-support-footer{", "}.phone-support-footer__tel{width:350px;", " .phone-support-container{", "}}*{z-index:1;}"], breakpoint.tablet(_t || (_t = _`
    justify-content: space-between;
    position: relative;
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)), breakpoint.tabletPortrait(_t3 || (_t3 = _`
      display: block;
    `)), breakpoint.tablet(_t4 || (_t4 = _`
      width: auto;
    `)), breakpoint.tabletPortrait(_t5 || (_t5 = _`
        padding: 0;
        text-align: left;
      `)));
const StyledHeading = styled(H1).withConfig({
  displayName: "PhoneSupportFooter__StyledHeading",
  componentId: "i9y3nz-1"
})(["font-size:24px;width:70%;", " ", ""], breakpoint.tablet(_t6 || (_t6 = _`
    width: auto;
    line-height: 1.4;
  `)), breakpoint.phone(_t7 || (_t7 = _`
    line-height: 1.37;
    font-size: 18px;
  `)));
function PhoneSupportFooter({
  phoneSourceId,
  screen
}) {
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsxs(StyledFlex, {
      className: "phone-support-footer",
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx(StyledHeading, {
        "data-selenium-id": "phone-support-footer-header",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.stillHaveQuestions"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "phone-support-footer__tel",
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          screen: screen,
          className: "phone-support-footer__contents",
          phoneSourceId: phoneSourceId,
          showCopy: false,
          border: false
        })
      })]
    })
  });
}
export default PhoneSupportFooter;